module.exports = __webpack_public_path__ + "img/live_wm.9260b47b.png";